module.exports = __webpack_public_path__ + "static/Translation-ee501256c28e6477dbd8a77a113af8ab.png";